import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

export const CartIntermediateProductInfoRedpoints: FC<{
  redPoints: number
}> = ({ redPoints }) => {
  return (
    redPoints > 0 && (
      <div
        className="text-dark-brand"
        data-qa-id="cart-intermediate-product-redpoints"
      >
        {'+ '}
        <FormattedMessage
          id="general.label.product.redPoints"
          values={{ redPoints }}
        />
      </div>
    )
  )
}
